import { render, staticRenderFns } from "./SendInvitationModal.vue?vue&type=template&id=341673d4&"
import script from "./SendInvitationModal.vue?vue&type=script&lang=ts&"
export * from "./SendInvitationModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendInvitationModal.vue?vue&type=style&index=0&id=341673d4&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports